// libraries.
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

// slices.
import { apiBudgetRoute } from "../apiSlices";

// interfaces.
import { ModelError } from "../interfaces/interfaces";
import {
  RawTool,
  RawContextColumn,
  RawToolsApiResponse,
} from "./interfaces/rawRules.interfaces";

// ─── Response shape ───────────────────────────────────────────────────────────

export interface RulesToolsData {
  tools: RawTool[];
  contextColumns: RawContextColumn[];
}

// ─── Endpoint ─────────────────────────────────────────────────────────────────

export const rulesToolsEndpoints = apiBudgetRoute.injectEndpoints({
  endpoints: (builder) => ({
    getRulesTools: builder.query<RulesToolsData, void>({
      query: () => ({
        url: "/rules/tools",
        method: "GET",
      }),
      transformErrorResponse: (error: FetchBaseQueryError) => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: "getRulesTools",
        };
        return modelError;
      },
      transformResponse: (raw: RawToolsApiResponse): RulesToolsData => ({
        tools: raw.data.tools,
        contextColumns: raw.data.context_columns ?? [],
      }),
    }),
  }),
});

export const { useGetRulesToolsQuery } = rulesToolsEndpoints;
